module.exports = __webpack_public_path__ + "static/media/pak.60380cbc.svg";